module.exports = __webpack_public_path__ + "static/media/mainBack.ce435d7d.jpg";